import { EnumEntry } from './EnumEntry';

export class EnumData {
    public userPermissions: EnumEntry[];
    public userRoles: EnumEntry[];
}


// WEBPACK FOOTER //
// ./src/models/EnumData.tsx